import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";

const HomeIcon = styled(HomeOutlined)`
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
export { HomeIcon };
